import { render, staticRenderFns } from "./Column1.vue?vue&type=template&id=74b68e62&scoped=true&"
import script from "./Column1.vue?vue&type=script&lang=js&"
export * from "./Column1.vue?vue&type=script&lang=js&"
import style1 from "./Column1.vue?vue&type=style&index=1&id=74b68e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b68e62",
  null
  
)

export default component.exports